module.exports = __webpack_public_path__ + "img/Craghoppers-Logo.c785f615.jpg";